import React from 'react';

interface IDCoderLogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark';
  className?: string;
}

const sizeClass = {
  sm: 'text-lg',
  md: 'text-2xl',
  lg: 'text-[1.65rem]',
} as const;

const colors = {
  light: {
    id: 'text-[#1e3a8a]',
    coder: 'text-[#2563eb]',
    bar: 'bg-[#38bdf8]',
  },
  dark: {
    id: 'text-white',
    coder: 'text-white/90',
    bar: 'bg-[#38bdf8]',
  },
} as const;

/** IDCoder wordmark: bold ID, Coder with the cyan bar under C. */
const IDCoderLogo: React.FC<IDCoderLogoProps> = ({ size = 'md', variant = 'light', className = '' }) => {
  const tone = colors[variant];
  return (
    <span
      className={`inline-flex items-baseline font-sans leading-none tracking-tight ${sizeClass[size]} ${className}`}
      aria-hidden
    >
      <span className={`font-bold ${tone.id}`}>ID</span>
      <span className={`relative font-semibold ${tone.coder}`}>
        C
        <span className={`absolute left-0 right-0 -bottom-[0.18em] h-[0.12em] rounded-full ${tone.bar}`} />
      </span>
      <span className={`font-medium ${tone.coder}`}>oder</span>
    </span>
  );
};

export default IDCoderLogo;
